/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import "./style.css";

import Header from "../components/header/Header";

import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import axios from "axios";
import Swal from "sweetalert2";

const Form = ({ register, errors }) => {
  return (
    <>
      <div className="amc-login-form-title">
        <h1>¡Bienvenido!</h1>
        <span>Ingresa tu usuario y contraseña</span>
      </div>
      <div className="amc-login-form-inputs">
        {/* Usuario */}
        <div className="formGroup">
          <input
            className="formInput"
            type="text"
            name="email"
            id="email"
            placeholder=""
            {...register("email", {
              required: "Este campo es requerido",
              pattern: {
                value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                message: "Formato de correo inválido",
              },
            })}
          />
          <label htmlFor="email" className="formLabel">
            Usuario
          </label>
          {errors.email && (
            <span className="alert-text">{errors.email.message}</span>
          )}
        </div>
        {/* Contraseña */}
        <div className="formGroup">
          <input
            className="formInput"
            type="password"
            autoComplete="current-password"
            name="password"
            id="password"
            placeholder=""
            {...register("password", {
              required: "Este campo es requerido",
            })}
          />
          <label htmlFor="password" className="formLabel">
            Password
          </label>
          {errors.password && (
            <span className="alert-text">{errors.password.message}</span>
          )}
        </div>
      </div>
      <div className="amc-login-buton">
        <button type="submit" className="amc-login-buton-next">
          {" "}
          Siguiente &#x276f;
        </button>
      </div>
    </>
  );
};

const Profile = ({
  permissos,
  profile,
  handleProfile,
  showError,
  navigateToProfile,
}) => {
  return (
    <>
      <div className="amc-login-profile">
        <div className="amc-login-profile-title">
          <h1>¡Bienvenido!</h1>
          <span>Selecciona el perfil que te corresponda</span>
        </div>
        <div className="amc-login-profile-type-profile">
          {/* Cliente */}
          {permissos.includes("13") && (
            <div className="profile-container">
              <input
                type="radio"
                id="cliente"
                name="profile"
                value="cliente"
                style={{ display: "none" }}
                onChange={handleProfile}
              />
              <label
                htmlFor="cliente"
                className="amc-login-profile-circle"
                style={
                  profile === "cliente" ? { backgroundColor: "#035cf7" } : {}
                }
              >
                <svg
                  width="50"
                  height="52"
                  viewBox="0 0 50 52"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.3158 12.3158C12.3158 19.1059 17.8415 24.6316 24.6316 24.6316C31.4217 24.6316 36.9474 19.1059 36.9474 12.3158C36.9474 5.52568 31.4217 0 24.6316 0C17.8415 0 12.3158 5.52568 12.3158 12.3158ZM46.5263 52H49.2632V49.2632C49.2632 38.7017 40.6667 30.1053 30.1053 30.1053H19.1579C8.59368 30.1053 0 38.7017 0 49.2632V52H46.5263Z"
                    fill="white"
                  />
                </svg>
              </label>
              <div className="amc-login-profile-label">
                <span>Cliente</span>
              </div>
            </div>
          )}

          {/* Pesador */}
          {permissos.includes("14") && (
            <div className="profile-container">
              <input
                type="radio"
                id="pesador"
                name="profile"
                value="pesador"
                style={{ display: "none" }}
                onChange={handleProfile}
              />
              <label
                htmlFor="pesador"
                className="amc-login-profile-circle"
                style={
                  profile === "pesador" ? { backgroundColor: "#035cf7" } : {}
                }
              >
                <svg
                  width="53"
                  height="52"
                  viewBox="0 0 53 52"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M25.7007 0.141812C25.9197 0.0482463 26.1556 0 26.3939 0C26.6323 0 26.8682 0.0482463 27.0872 0.141812L51.0283 10.3662L26.3939 20.8851L1.7596 10.3662L25.7007 0.141812ZM0 13.4307V40.324C0 41.0253 0.422303 41.6564 1.06632 41.9369L24.6343 52V23.9496L0 13.4307ZM28.1535 23.9496L52.7879 13.4307V40.324C52.7882 40.6674 52.6873 41.0032 52.4977 41.29C52.3082 41.5767 52.0383 41.8016 51.7216 41.9369L28.1535 52V23.9496Z"
                    fill="white"
                  />
                </svg>
              </label>
              <div className="amc-login-profile-label">
                <span>Pesador</span>
              </div>
            </div>
          )}

          {/* Documentador */}
          {permissos.includes("15") && (
            <div className="profile-container">
              <input
                type="radio"
                id="mostrador"
                value="mostrador"
                name="profile"
                style={{ display: "none" }}
                onChange={handleProfile}
              />
              <label
                htmlFor="mostrador"
                className="amc-login-profile-circle"
                style={
                  profile === "mostrador" ? { backgroundColor: "#035cf7" } : {}
                }
              >
                <svg
                  width="53"
                  height="52"
                  viewBox="0 0 53 52"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M22.878 9.81658C25.6704 11.6451 27.7083 14.4207 28.6167 17.6325C29.5251 20.8443 29.2428 24.2761 27.8218 27.2963C30.359 29.2499 33.4475 30.3541 36.6483 30.4518C39.8491 30.5496 42.9992 29.6359 45.6509 27.8406C48.3026 26.0454 50.321 23.46 51.4191 20.4519C52.5172 17.4438 52.6392 14.1661 51.7677 11.0847C50.8962 8.00334 49.0756 5.27507 46.5646 3.28772C44.0536 1.30038 40.9801 0.155088 37.781 0.014657C34.5818 -0.125775 31.4197 0.745797 28.7443 2.50548C26.0689 4.26516 24.0162 6.82341 22.878 9.81658ZM37.1195 13.8212C38.4155 13.8212 39.4674 14.873 39.4674 16.1691V22.9085C39.4674 23.5312 39.22 24.1284 38.7797 24.5687C38.3394 25.009 37.7422 25.2564 37.1195 25.2564C36.4968 25.2564 35.8996 25.009 35.4593 24.5687C35.0189 24.1284 34.7716 23.5312 34.7716 22.9085V16.1691C34.7716 14.873 35.8234 13.8212 37.1195 13.8212ZM34.3658 7.88566C34.3658 9.65504 35.8309 10.4327 36.864 10.5454L37.127 10.5604C38.1526 10.5604 39.8844 9.80907 39.8844 7.88566C39.8844 6.11252 38.4193 5.3349 37.3862 5.2222L37.1232 5.20717C36.0977 5.20717 34.3658 5.9585 34.3658 7.88566ZM15.2708 30.5683C16.4899 30.593 17.7017 30.3742 18.8351 29.9247C19.9686 29.4753 21.001 28.8042 21.8719 27.9507C22.7428 27.0973 23.4347 26.0787 23.907 24.9545C24.3793 23.8304 24.6226 22.6233 24.6226 21.404C24.6226 20.1846 24.3793 18.9775 23.907 17.8534C23.4347 16.7292 22.7428 15.7106 21.8719 14.8572C21.001 14.0038 19.9686 13.3327 18.8351 12.8832C17.7017 12.4337 16.4899 12.2149 15.2708 12.2396C12.8724 12.2882 10.5886 13.275 8.90958 14.9884C7.23056 16.7018 6.29013 19.0051 6.29013 21.404C6.29013 23.8029 7.23056 26.1062 8.90958 27.8195C10.5886 29.5329 12.8724 30.5198 15.2708 30.5683ZM2.01833e-05 48.8933C-0.00621099 45.0585 1.43057 41.3617 4.02483 38.5376C6.6191 35.7136 10.1809 33.9689 14.0025 33.6504C17.824 33.3319 21.6255 34.4629 24.6514 36.8185C27.6774 39.1742 29.7063 42.5821 30.335 46.365H49.708C50.4553 46.365 51.1719 46.6619 51.7003 47.1903C52.2287 47.7186 52.5255 48.4353 52.5255 49.1825C52.5255 49.9298 52.2287 50.6464 51.7003 51.1748C51.1719 51.7032 50.4553 52 49.708 52H2.89264C2.17934 51.9998 1.49266 51.7291 0.971147 51.2424C0.449637 50.7558 0.132122 50.0894 0.0826665 49.3779C0.0299787 49.2217 0.00332649 49.058 0.00377683 48.8933H2.01833e-05Z"
                    fill="white"
                  />
                </svg>
              </label>
              <div className="amc-login-profile-label">
                <span>Documentador</span>
              </div>
            </div>
          )}

          {/* Pantalla turnos */}
          {permissos.includes("16") && (
            <div className="profile-container">
              <input
                type="radio"
                id="supervidor_principal"
                value="supervidor_principal"
                name="profile"
                style={{ display: "none" }}
                onChange={handleProfile}
              />
              <label
                htmlFor="supervidor_principal"
                className="amc-login-profile-circle"
                style={
                  profile === "supervidor_principal"
                    ? { backgroundColor: "#035cf7" }
                    : {}
                }
              >
                <svg
                  width="43"
                  height="52"
                  viewBox="0 0 43 52"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M21.2727 0L0 9.45455V23.6364C0 36.7545 9.07636 49.0218 21.2727 52C33.4691 49.0218 42.5455 36.7545 42.5455 23.6364V9.45455L21.2727 0ZM21.2727 9.21818C22.6752 9.21818 24.0461 9.63406 25.2122 10.4132C26.3783 11.1924 27.2872 12.2998 27.8239 13.5955C28.3606 14.8912 28.501 16.317 28.2274 17.6925C27.9538 19.068 27.2784 20.3314 26.2868 21.3231C25.2951 22.3148 24.0316 22.9901 22.6561 23.2637C21.2806 23.5374 19.8548 23.3969 18.5592 22.8602C17.2635 22.3235 16.156 21.4147 15.3769 20.2486C14.5977 19.0825 14.1818 17.7115 14.1818 16.3091C14.1818 14.4285 14.9289 12.6249 16.2587 11.2951C17.5885 9.96526 19.3921 9.21818 21.2727 9.21818ZM21.2727 27.8909C26 27.8909 35.4545 30.4673 35.4545 35.1709C33.9022 37.5112 31.7948 39.4309 29.3203 40.7589C26.8458 42.0869 24.0811 42.7819 21.2727 42.7819C18.4644 42.7819 15.6997 42.0869 13.2252 40.7589C10.7507 39.4309 8.64328 37.5112 7.09091 35.1709C7.09091 30.4673 16.5455 27.8909 21.2727 27.8909Z"
                    fill="white"
                  />
                </svg>
              </label>
              <div className="amc-login-profile-label">
                <span style={{ textAlign: "center" }}>
                  Pantalla turnos Principal
                </span>
              </div>
            </div>
          )}

          {permissos.includes("44") && (
            <div className="profile-container">
              <input
                type="radio"
                id="supervidor_secondary"
                value="supervidor_secondary"
                name="profile"
                style={{ display: "none" }}
                onChange={handleProfile}
              />
              <label
                htmlFor="supervidor_secondary"
                className="amc-login-profile-circle"
                style={
                  profile === "supervidor_secondary"
                    ? { backgroundColor: "#035cf7" }
                    : {}
                }
              >
                <svg
                  width="43"
                  height="52"
                  viewBox="0 0 43 52"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M21.2727 0L0 9.45455V23.6364C0 36.7545 9.07636 49.0218 21.2727 52C33.4691 49.0218 42.5455 36.7545 42.5455 23.6364V9.45455L21.2727 0ZM21.2727 9.21818C22.6752 9.21818 24.0461 9.63406 25.2122 10.4132C26.3783 11.1924 27.2872 12.2998 27.8239 13.5955C28.3606 14.8912 28.501 16.317 28.2274 17.6925C27.9538 19.068 27.2784 20.3314 26.2868 21.3231C25.2951 22.3148 24.0316 22.9901 22.6561 23.2637C21.2806 23.5374 19.8548 23.3969 18.5592 22.8602C17.2635 22.3235 16.156 21.4147 15.3769 20.2486C14.5977 19.0825 14.1818 17.7115 14.1818 16.3091C14.1818 14.4285 14.9289 12.6249 16.2587 11.2951C17.5885 9.96526 19.3921 9.21818 21.2727 9.21818ZM21.2727 27.8909C26 27.8909 35.4545 30.4673 35.4545 35.1709C33.9022 37.5112 31.7948 39.4309 29.3203 40.7589C26.8458 42.0869 24.0811 42.7819 21.2727 42.7819C18.4644 42.7819 15.6997 42.0869 13.2252 40.7589C10.7507 39.4309 8.64328 37.5112 7.09091 35.1709C7.09091 30.4673 16.5455 27.8909 21.2727 27.8909Z"
                    fill="white"
                  />
                </svg>
              </label>
              <div className="amc-login-profile-label">
                <span style={{ textAlign: "center" }}>
                  Pantalla turnos Secundaria
                </span>
              </div>
            </div>
          )}

          {/* Inspector */}
          {permissos.includes("17") && (
            <div className="profile-container">
              <input
                type="radio"
                id="guardia"
                value="guardia"
                name="profile"
                style={{ display: "none" }}
                onChange={handleProfile}
              />
              <label
                htmlFor="guardia"
                className="amc-login-profile-circle"
                style={
                  profile === "guardia" ? { backgroundColor: "#035cf7" } : {}
                }
              >
                <svg
                  width="55"
                  height="52"
                  viewBox="0 0 55 52"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.9474 10.9474C10.9474 4.89895 15.8463 0 21.8947 0C27.9432 0 32.8421 4.89895 32.8421 10.9474C32.8421 16.9958 27.9432 21.8947 21.8947 21.8947C15.8463 21.8947 10.9474 16.9958 10.9474 10.9474ZM27.3684 38.8632C27.3684 36.2358 28.7368 33.7726 30.6526 32.1305V31.4737C30.6526 30.4063 30.8442 29.3937 31.1453 28.4084C28.3263 27.7516 25.2063 27.3684 21.8947 27.3684C9.79789 27.3684 0 32.2674 0 38.3158V43.7895H27.3684V38.8632ZM54.7368 39.1368V48.7158C54.7368 50.3579 53.0947 52 51.179 52H36.1263C34.4842 52 32.8421 50.3579 32.8421 48.4421V38.8632C32.8421 37.2211 34.4842 35.5789 36.1263 35.5789V31.4737C36.1263 27.6421 39.9579 24.6316 43.7895 24.6316C47.6211 24.6316 51.4526 27.6421 51.4526 31.4737V35.5789C53.0947 35.5789 54.7368 37.2211 54.7368 39.1368ZM47.8947 31.4737C47.8947 29.2842 45.9789 27.9158 43.7895 27.9158C41.6 27.9158 39.6842 29.2842 39.6842 31.4737V35.5789H47.8947V31.4737Z"
                    fill="white"
                  />
                </svg>
              </label>
              <div className="amc-login-profile-label">
                <span>Inspector</span>
              </div>
            </div>
          )}

          {/* Reimpresion de Turnos */}
          {permissos.includes("39") && (
            <div className="profile-container">
              <input
                type="radio"
                id="reprint_shifts"
                value="reprint_shifts"
                name="profile"
                style={{ display: "none" }}
                onChange={handleProfile}
              />
              <label
                htmlFor="reprint_shifts"
                className="amc-login-profile-circle"
                style={
                  profile === "reprint_shifts"
                    ? { backgroundColor: "#035cf7" }
                    : {}
                }
              >
                <svg
                  stroke="#fff"
                  fill="#fff"
                  stroke-width="0"
                  viewBox="0 0 512 512"
                  height="55px"
                  width="52px"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M128 0C92.7 0 64 28.7 64 64l0 96 64 0 0-96 226.7 0L384 93.3l0 66.7 64 0 0-66.7c0-17-6.7-33.3-18.7-45.3L400 18.7C388 6.7 371.7 0 354.7 0L128 0zM384 352l0 32 0 64-256 0 0-64 0-16 0-16 256 0zm64 32l32 0c17.7 0 32-14.3 32-32l0-96c0-35.3-28.7-64-64-64L64 192c-35.3 0-64 28.7-64 64l0 96c0 17.7 14.3 32 32 32l32 0 0 64c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-64zM432 248a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"></path>
                </svg>
              </label>
              <div className="amc-login-profile-label text-center">
                <span>Reimpresion de Turno</span>
              </div>
            </div>
          )}

          {/* Turnos */}
          {permissos.includes("40") && (
            <div className="profile-container">
              <input
                type="radio"
                id="turns"
                value="turns"
                name="profile"
                style={{ display: "none" }}
                onChange={handleProfile}
              />
              <label
                htmlFor="turns"
                className="amc-login-profile-circle"
                style={
                  profile === "turns" ? { backgroundColor: "#035cf7" } : {}
                }
              >
                <svg
                  width="43"
                  height="52"
                  viewBox="0 0 43 52"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M21.2727 0L0 9.45455V23.6364C0 36.7545 9.07636 49.0218 21.2727 52C33.4691 49.0218 42.5455 36.7545 42.5455 23.6364V9.45455L21.2727 0ZM21.2727 9.21818C22.6752 9.21818 24.0461 9.63406 25.2122 10.4132C26.3783 11.1924 27.2872 12.2998 27.8239 13.5955C28.3606 14.8912 28.501 16.317 28.2274 17.6925C27.9538 19.068 27.2784 20.3314 26.2868 21.3231C25.2951 22.3148 24.0316 22.9901 22.6561 23.2637C21.2806 23.5374 19.8548 23.3969 18.5592 22.8602C17.2635 22.3235 16.156 21.4147 15.3769 20.2486C14.5977 19.0825 14.1818 17.7115 14.1818 16.3091C14.1818 14.4285 14.9289 12.6249 16.2587 11.2951C17.5885 9.96526 19.3921 9.21818 21.2727 9.21818ZM21.2727 27.8909C26 27.8909 35.4545 30.4673 35.4545 35.1709C33.9022 37.5112 31.7948 39.4309 29.3203 40.7589C26.8458 42.0869 24.0811 42.7819 21.2727 42.7819C18.4644 42.7819 15.6997 42.0869 13.2252 40.7589C10.7507 39.4309 8.64328 37.5112 7.09091 35.1709C7.09091 30.4673 16.5455 27.8909 21.2727 27.8909Z"
                    fill="white"
                  />
                </svg>
              </label>
              <div className="amc-login-profile-label text-center">
                <span>Turno</span>
              </div>
            </div>
          )}

          {/* Administrador */}
          {permissos.includes("42") && (
            <div className="profile-container">
              <input
                type="radio"
                id="administrator"
                value="administrator"
                name="profile"
                style={{ display: "none" }}
                onChange={handleProfile}
              />
              <label
                htmlFor="administrator"
                className="amc-login-profile-circle"
                style={
                  profile === "administrator" ? { backgroundColor: "#035cf7" } : {}
                }
              >
                <svg 
                  fill="white" 
                  viewBox="0 0 448 512" 
                  height="43px" 
                  width="52px" 
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M400 0H48C22.4 0 0 22.4 0 48v416c0 25.6 22.4 48 48 48h352c25.6 0 48-22.4 48-48V48c0-25.6-22.4-48-48-48zM128 435.2c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm0-128c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm128 128c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm0-128c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm128 128c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8V268.8c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v166.4zm0-256c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8V76.8C64 70.4 70.4 64 76.8 64h294.4c6.4 0 12.8 6.4 12.8 12.8v102.4z"></path>
                </svg>
              </label>
              <div className="amc-login-profile-label text-center">
                <span>Administrador</span>
              </div>
            </div>
          )}
        </div>
        {showError && (
          <span className="alert-text">Debe selecionar un perfil</span>
        )}

        <div className="amc-login-buton">
          <button
            type="button"
            className="amc-login-buton-next"
            onClick={navigateToProfile}
          >
            {" "}
            Iniciar Sesión &#x276f;
          </button>
        </div>
      </div>
    </>
  );
};

const LoginDomestico = () => {
  const [step, setStep] = useState(1);
  const [permissions, setPermissions] = useState([]);
  const [profile, setProfile] = useState("");
  const [showError, setShowError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: "onChange" });

  const login = async (data) => {
    setIsLoading(true);
    const body = { email: data.email, password: data.password };

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_LIGHT_LOAD}/user/login`,
        body
      );
      if (res.data.code === 1) {
        const user = res.data.data;
        localStorage.setItem("light-load-user", user.name);
        localStorage.setItem("light-load-email", user.email);
        localStorage.setItem("light-load-token", user.token);
        localStorage.setItem("light-load-permissos", user.permissions);
        localStorage.setItem("light-load-kpi_id", user.kpi_id);
        if (user.counter_checkout.id !== null) {
          localStorage.setItem("counterId", user.counter_checkout.id);
        }
        setPermissions(user?.permissions);
        setStep(2);
        setIsLoading(false);
      } else {
        throw new Error(res);
      }
    } catch (error) {
      console.error(error);
      if (
        error.response.data.code === -1 ||
        error.response.data.message === "Correo o contraseña incorrectos"
      ) {
        Swal.fire("Error", "Correo o contraseña incorrectos", "error");
        setIsLoading(false);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleProfile = (e) => {
    setProfile(e.target.value);
  };

  const getProfileNumber = (profile) => {
    switch (profile) {
      case "cliente":
        return "1";
      case "pesador":
        return "2";
      case "mostrador":
        return "3";
      case "supervidor_principal":
        return "4";
      case "supervidor_secondary":
        return "4";
      case "guardia":
        return "5";
      case "turns":
        return "6";
      default:
        return "";
    }
  };

  const navigateToProfile = async () => {
    if (profile) {
      try {
        const url = `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_LIGHT_LOAD}/user/operation`;
        const body = {
          kpi_id: localStorage.getItem("light-load-kpi_id"),
          profile: getProfileNumber(profile),
        };
        const response = await axios.put(url, body, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("light-load-token")}`,
          },
        });

        const profileRoutes = {
          cliente: "/amc-domestico/light-load/clients",
          pesador: "/amc-domestico/light-load/weigher",
          mostrador: "/amc-domestico/light-load/approved-registration",
          supervidor_principal: "/amc-domestico/light-load/reception",
          supervidor_secondary: "/amc-domestico/light-load/reception-nv",
          guardia: "/amc-domestico/light-load/weighing-control",
          reprint_shifts: "/amc-domestico/light-load/reprint_shifts",
          turns: "/amc-domestico/light-load/turns",
          administrator: "/amc-domestico/light-load/administrator",
        };

        navigate(profileRoutes[profile], {
          state: { from: "/amc-domestico/light-load" },
        });
      } catch (error) {
        console.error(error);
      }
    } else {
      setShowError(true);
    }
  };

  return (
    <>
      <div className="amc-login">
        <Header />
        <form onSubmit={handleSubmit(login)} autoComplete="off">
          <div className="amc-login-form">
            {isLoading ? (
              <div className="loading-spinner">
                <Spinner animation="border" role="status">
                  <span className="visually-hidden">Cargando...</span>
                </Spinner>
              </div>
            ) : step === 1 ? (
              <Form register={register} errors={errors} />
            ) : (
              <Profile
                permissos={permissions}
                profile={profile}
                handleProfile={handleProfile}
                showError={showError}
                navigateToProfile={navigateToProfile}
              />
            )}
          </div>
        </form>
      </div>
    </>
  );
};

export default LoginDomestico;
